import { render } from "./ProLabelBig.vue?vue&type=template&id=2ae02e06&scoped=true"
const script = {}

import "./ProLabelBig.vue?vue&type=style&index=0&id=2ae02e06&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ae02e06"]])

export default __exports__